import { inferAdditionalFields, magicLinkClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import type { serverAuth } from "./auth";

export const clientAuth = createAuthClient({
  plugins: [inferAdditionalFields<typeof serverAuth>(), magicLinkClient()],
});
